import { ReactNode } from 'react';
import { FieldValues, UseFormHandleSubmit } from 'react-hook-form';

type FormWrapperProps<TFormData extends FieldValues> = {
  children: ReactNode;
  handleSubmit: UseFormHandleSubmit<TFormData>;
  onSubmit: (formData: TFormData) => Promise<void>;
};

const FormWrapper = <TFormData extends FieldValues>({
  children,
  handleSubmit,
  onSubmit,
}: FormWrapperProps<TFormData>) => {
  return (
    <form onSubmit={handleSubmit(onSubmit)} className="w-full">
      {children}
    </form>
  );
};

export default FormWrapper;
